/**
 * @generated SignedSource<<eb12e30cf1c1449c7e85a800e1abdb12>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type OrganizationCurrency = "aed" | "afn" | "all" | "amd" | "ang" | "aoa" | "ars" | "aud" | "awg" | "azn" | "bam" | "bbd" | "bdt" | "bgn" | "bmd" | "bnd" | "bob" | "brl" | "bsd" | "bwp" | "byn" | "bzd" | "cad" | "chf" | "cny" | "cop" | "crc" | "cve" | "czk" | "dkk" | "dop" | "dzd" | "egp" | "etb" | "eur" | "fjd" | "fkp" | "gbp" | "gel" | "gip" | "gmd" | "hkd" | "hnl" | "htg" | "huf" | "idr" | "ils" | "inr" | "isk" | "jmd" | "kgs" | "lak" | "lbp" | "lkr" | "lrd" | "lsl" | "mad" | "mdl" | "mkd" | "mmk" | "mnt" | "mop" | "mur" | "mvr" | "mxn" | "myr" | "mzn" | "nad" | "ngn" | "nio" | "nok" | "npr" | "nzd" | "pab" | "pen" | "pgk" | "php" | "pkr" | "pln" | "qar" | "ron" | "rsd" | "rub" | "sar" | "sbd" | "scr" | "sek" | "sgd" | "shp" | "srd" | "std" | "szl" | "thb" | "tjs" | "top" | "try" | "ttd" | "twd" | "uah" | "usd" | "uyu" | "uzs" | "zar" | "zmw" | "%future added value";
export type UpdateOrganizationCurrencyInput = {
  currency: OrganizationCurrency;
};
export type ConnectStripeModalContent_UpdateCurrencyMutation$variables = {
  input: UpdateOrganizationCurrencyInput;
  returnTo: string;
};
export type ConnectStripeModalContent_UpdateCurrencyMutation$data = {
  readonly response: {
    readonly errors: ReadonlyArray<{
      readonly field: string;
      readonly message: string;
    }> | null;
    readonly node: {
      readonly currency: OrganizationCurrency;
      readonly id: string;
      readonly stripeAccountId: string | null;
      readonly stripeOauthAuthorizeUrl: string | null;
    } | null;
  };
};
export type ConnectStripeModalContent_UpdateCurrencyMutation = {
  response: ConnectStripeModalContent_UpdateCurrencyMutation$data;
  variables: ConnectStripeModalContent_UpdateCurrencyMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "returnTo"
  }
],
v1 = [
  {
    "alias": "response",
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateOrganizationCurrencyMutationResponse",
    "kind": "LinkedField",
    "name": "updateOrganizationCurrency",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Organization",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "currency",
            "storageKey": null
          },
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "returnTo",
                "variableName": "returnTo"
              }
            ],
            "kind": "ScalarField",
            "name": "stripeOauthAuthorizeUrl",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "stripeAccountId",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "ValidationError",
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "field",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "message",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ConnectStripeModalContent_UpdateCurrencyMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ConnectStripeModalContent_UpdateCurrencyMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "6b70592a9a56259c99ad03b7760970a8",
    "id": null,
    "metadata": {},
    "name": "ConnectStripeModalContent_UpdateCurrencyMutation",
    "operationKind": "mutation",
    "text": "mutation ConnectStripeModalContent_UpdateCurrencyMutation(\n  $input: UpdateOrganizationCurrencyInput!\n  $returnTo: String!\n) {\n  response: updateOrganizationCurrency(input: $input) {\n    node {\n      id\n      currency\n      stripeOauthAuthorizeUrl(returnTo: $returnTo)\n      stripeAccountId\n    }\n    errors {\n      field\n      message\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "3dadd6aac8182f445b66cf46122eca41";

export default node;
